import { useEffect, useState } from "react";
import api from "../lib/api";
import BranchPicker from "../components/BranchPicker";

const levelCls = { expired: "bg-red-100 text-red-700", critical: "bg-orange-100 text-orange-700", warning: "bg-amber-100 text-amber-700", ok: "bg-emerald-100 text-emerald-700" };

export default function Compliance() {
  const [rows, setRows] = useState([]);
  const [branchId, setBranchId] = useState(null);
  useEffect(() => { api.get("/compliance", { params: { branch_id: branchId || undefined } }).then((r) => setRows(r.data)); }, [branchId]);

  return (
    <div className="px-4 py-5 lg:px-8 max-w-3xl">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-heading text-2xl font-bold text-[#0E2240]">Compliance</h1>
        <BranchPicker value={branchId} onChange={setBranchId} />
      </div>
      <p className="text-xs text-slate-500 mt-0.5">Insurance · PUC · Service due — reminders at 30/15/7 days</p>
      <div className="mt-4 space-y-3">
        {rows.map((r) => (
          <div key={r.vehicle_id} data-testid={`compliance-card-${r.reg_no}`} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="font-heading font-bold text-[#0E2240]">{r.reg_no} · {r.model}</div>
            <div className="mt-2 flex flex-wrap gap-2">
              {r.items.map((i, idx) => (
                <span key={idx} className={`rounded-full px-2.5 py-1 text-[11px] font-bold ${levelCls[i.level]}`}>
                  {i.item}: {i.due} {i.level === "expired" ? "(EXPIRED)" : typeof i.days_left === "number" && i.days_left < 999 ? `(${i.days_left}d)` : ""}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
